// @ts-nocheck

import { createFileRoute, useNavigate } from '@tanstack/react-router'
import '../App.css'
import '@fontsource/montserrat';
import Clients from '../components/Clients/Clients';

export const Route = createFileRoute('/clients')({
  component: RouteComponent,
})

function RouteComponent() {
  
  return <Clients/>
}

